import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { RedePergamumAPI } from '../../../../shared/http-requests';
import { Col, Input, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorPage from '../ErrorPage';
import { SpinnerConstructor } from '../../../../shared/components';
import { useTranslation } from 'react-i18next';

const ModalInstituicoesOAI = props => {
    const [instituicoes, setInstituicoes] = useState(false);
    const [checked, setChecked] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let cancelToken = Axios.CancelToken.source();

        RedePergamumAPI.buscarInstituicoesOAI(cancelToken.token)
            .then(response => {
                setInstituicoes(response.data);
                //Checa todos por padrão
                setChecked(response.data.map(i => i.cod_empresa));
            })
            .catch(error => {
                if (!Axios.isCancel(error))
                    setInstituicoes({
                        error: true,
                        message: error.response.data.message,
                    });
            });

        //? cleanup
        return () => cancelToken.cancel();
    }, []);

    const checkInstituicao = codEmpresa => {
        if (checked.some(chk => chk === codEmpresa)) {
            setChecked(chk => chk.filter(c => c !== codEmpresa));
        } else {
            setChecked(chk => [...chk, codEmpresa]);
        }
    };

    const checkTodos = e => {
        if (e.target.checked) {
            let array = [...instituicoes].map(i => i.cod_empresa);
            setChecked(array);
        } else {
            setChecked([]);
        }
    };

    const pesquisarOAI = () => {
        let empresas = checked.join(',');
        props.closeModal();
        props.pesquisarCallback('rede_pergamum_oai', empresas);
    };

    return (
        <Row className="p-3">
            <Col
                md="12"
                xs="12"
                className="b-w1 b-solid-bottom b-tema20 p-3 mb-2 text-center"
            >
                <button
                    className="bkverde hover htema pad5 rad5 b-none branco sverde"
                    disabled={checked.length === 0}
                    onClick={() => pesquisarOAI()}
                >
                    <FontAwesomeIcon icon="search" className="s14 r5" />
                    {t('Pesquisar')}
                </button>
            </Col>
            {instituicoes ? (
                !instituicoes.error ? (
                    <>
                        <Col
                            md="6"
                            xs="12"
                            className="animated fadeIn pb-2 pt-2"
                        >
                            <Input
                                id={`chk-todos`}
                                type="checkbox"
                                className="preto f500 click hover1 s14 mr-1"
                                checked={instituicoes.every(i =>
                                    checked.includes(i.cod_empresa),
                                )}
                                onChange={e => checkTodos(e)}
                            />
                            <label htmlFor={`chk-todos`} className="preto f500 click hover1 s14 ml-1">
                                {t('TodasInstituicoes')}
                            </label>
                        </Col>
                        {instituicoes.map((inst, idx) => (
                            <Col
                                md="6"
                                xs="12"
                                key={`inst-${inst.cod_empresa}`}
                                className="animated fadeIn pb-2 pt-2"
                            >
                                <Input
                                    id={`chk-empresa-${idx}`}
                                    type="checkbox"
                                    className="preto80 click hover1 s14 mr-1"
                                    checked={checked.some(
                                        chk => chk === inst.cod_empresa,
                                    )}
                                    onChange={() =>
                                        checkInstituicao(inst.cod_empresa)
                                    }
                                />
                                <label htmlFor={`chk-empresa-${idx}`} className="preto80 click hover1 s14 ml-1">
                                    {`${inst.sigla_empresa} - ${inst.desc_empresa}`}
                                </label>
                            </Col>
                        ))}
                    </>
                ) : (
                    <ErrorPage msg={instituicoes.message} />
                )
            ) : (
                <Col md="12" xs="12" className="p-5 text-center">
                    <SpinnerConstructor
                        visible
                        className="s20 cortxt70"
                        height={80}
                        width={80}
                        showLabel
                    />
                </Col>
            )}
        </Row>
    );
};


export default  ModalInstituicoesOAI;
